const errorSupportClass = `
  text-error-l20
`

export const getSupportDefault = (error: boolean): string => {
  const defaultSupportClass = `
    text-grey
  `
  return error ? errorSupportClass : defaultSupportClass
}

export const getSupportDisabled = (error: boolean): string => {
  const disabledSupportClass = `
    text-grey-l60
  `
  return error ? errorSupportClass : disabledSupportClass
}
